import React from 'react';

const LittlePigsStaticElements: React.FC = () => {
  return (
    <g className="little-pigs-static-elements">
      <path fill="#68c902" d="M0 199h1522.8v578.1H0z" />
      <linearGradient
        id="prefix__a"
        gradientUnits="userSpaceOnUse"
        x1={760.005}
        y1={-69.248}
        x2={763.005}
        y2={316.251}
      >
        <stop offset={0.001} stopColor="#11b3ee" />
        <stop offset={0.068} stopColor="#2ebdf0" />
        <stop offset={0.189} stopColor="#5eccf4" />
        <stop offset={0.314} stopColor="#86d9f6" />
        <stop offset={0.441} stopColor="#a8e4f9" />
        <stop offset={0.57} stopColor="#c1ecfb" />
        <stop offset={0.704} stopColor="#d4f2fc" />
        <stop offset={0.844} stopColor="#def6fd" />
        <stop offset={1} stopColor="#e2f7fd" />
      </linearGradient>
      <path fill="url(#prefix__a)" d="M0 0h1522.8v218.1H0z" />
      <path
        d="M80.2 119.9c4.2-18.9 12.2-37.7 26.6-50.6s36.1-18.9 53.8-11c18.5-23.3 55-29.9 80.5-14.4 22.4-22.9 60.7-28.1 88.5-12C348.8 43 362 62.4 380.3 75c4.2 2.9 9.2 5.6 14.2 4.5 7.7-1.7 11-11 17.8-15 9.4-5.7 23.6 3.8 22 14.7C462 59.9 505.2 69 522.7 97.9c10.7-1.8 22.5-2.7 33-.2s20.6 10.3 22.3 21c9.5-11.1 26.6-13.1 40.5-8.7 14 4.4 25.6 14.1 36.8 23.5 11.1 9.3 22.8 19.4 26.7 33.4.8 2.7 1.2 5.9-.5 8.2-1.5 2.1-4.3 2.8-6.8 3.3-18 3.4-36.6 2-54.9.8-117.1-7.8-234.9-6.5-351.8 3.9-62.5 5.6-125.1 13.7-187.8 12.4-3.6-.1-7.4-.3-10.2-2.5-3.2-2.6-4-7-4.4-11-2-20.1 10.2-42.6 14.6-62.1z"
        fill="#e2f7fd"
      />
      <linearGradient
        id="prefix__b"
        gradientUnits="userSpaceOnUse"
        x1={381.979}
        y1={53.678}
        x2={366.979}
        y2={162.678}
      >
        <stop offset={0.001} stopColor="#c2d4fb" />
        <stop offset={0.033} stopColor="#c4d6fb" />
        <stop offset={0.333} stopColor="#d5e9fc" />
        <stop offset={0.648} stopColor="#dff3fd" />
        <stop offset={1} stopColor="#e2f7fd" />
      </linearGradient>
      <path
        d="M577.5 130.2c-60.2-.8-82.7 10.7-82.7 10.7s-39-46.5-82.5-51.5-81.5 25.5-81.5 25.5-11-43.9-42.5-49.7C256.8 59.4 234.8 80 234.8 80s-35.3-39.1-75.6 1.9c-26.7-8-48.4-6.3-64 .8-7.4 11.1-12.1 24.1-15.1 37.2-4.4 19.5-16.6 42-14.7 61.9.4 4.1 1.2 8.5 4.4 11 2.8 2.2 6.6 2.4 10.2 2.5 62.8 1.4 125.3-6.8 187.8-12.4 116.9-10.4 234.7-11.7 351.8-3.9 15 1 30.1 2.1 45 .6-10.4-14.6-39.9-48.7-87.1-49.4z"
        fill="url(#prefix__b)"
      />
      <path
        d="M574.3 72c5.7 4.8 13.8 6.6 21.1 4.8 7.2-1.9 13.5-7.3 16.2-14.3 5.4 1.7 12.8 2.2 15.1-2.9 1.9-4.2-1.4-8.9-4.6-12.3-1.7-14.4-25.5-29.7-38.3-29.7-9.5 0-14.4 2.4-14.7 4.3-6-2.1-12.3-3.3-18.6-3.4-4.2-.1-9.9 2.2-8.9 6.3-2.5-2.8-7.1-2.9-10.3-.9-3.2 2-5.1 5.5-6.1 9.2-1.7 5.9-.6 12.8 4.8 16.4-29.7 12.8 44.7 45.6 44.3 22.5zM1034.7 99.8c.3-15.7 8.9-31 22.2-39.3 13.3-8.4 30.8-9.6 45.1-3.1 24.6-26.5 68.3-32.9 99.4-14.5 14-25.1 43.4-40.7 72.1-38.2 2.6-1.7 5.3-3.2 8-4.6 33.2.3 120 0 124.3 0 9.2 4.7 17.9 10.5 25.7 17.4 10.5-6.2 24-3.6 35.2 1.2 11.2 4.8 21.7 11.7 33.6 14 7.4 1.4 15.3 1.1 22.4 3.4-.2 5.3-.3 41.6-.1 54.7-79.2 6.1-156.4 37.9-236 48.3-35.7 4.7-72 5-107.5 11.8-34 6.5-66.8 18.8-101.2 22.2-23.7 2.3-97.9 6.8-107.6-22.2-10.6-31.9 38.7-60.2 64.4-51.1z"
        fill="#e2f7fd"
      />
      <path
        d="M1241.4 92.4c-86.2-57.3-226.2-98.9-538.2 70.8 147.9 156.3 538.2-70.8 538.2-70.8z"
        fill="#78df0b"
      />
      <path
        d="M803.8 238.5c-91.7-5.9-203.1-135-395-138.4C284.9 97.9.1 234.3.1 234.3v4.2h803.7z"
        fill="#9ae1c2"
      />
      <path
        d="M0 65.3c92.7 7.8 275.6 86.7 344.3 117.6L.1 255.9 0 65.3z"
        fill="#78df0b"
      />
      <path
        d="M1522.8 83.7s-121.4-57.9-281.4-39.9-436.6 107.3-530.6 112.8-377-11.1-480.5-9S0 199 0 199v96.7h1522.8V93.8"
        fill="#68c902"
      />
      <path
        d="M898.5 55.6c-2.5 1.4-6.3 3.4-8.3 1.1-1.9-2.3 1.8-6.6 5-7.4-4.5-2.2-8.6-1.1-12-5.4s-3.4-8.3-2.5-12.4 3.9-8 8-8.8c1.9-.4 4 0 5.9.5 7.4 1.8 14.3 5.3 20.1 10.3.3-4 3.8-7.5 7.5-9.1 3.9-1.7 17.7 1.2 15.2 11-4.1 16-29.2 26.7-36.4 24.8-2.7-.9-2.5-4.6-2.5-4.6z"
        fill="#e2f7fd"
      />
      <linearGradient
        id="prefix__c"
        gradientUnits="userSpaceOnUse"
        x1={606.278}
        y1={27.841}
        x2={532.444}
        y2={88.341}
      >
        <stop offset={0.001} stopColor="#c2d4fb" />
        <stop offset={0.033} stopColor="#c4d6fb" />
        <stop offset={0.333} stopColor="#d5e9fc" />
        <stop offset={0.648} stopColor="#dff3fd" />
        <stop offset={1} stopColor="#e2f7fd" />
      </linearGradient>
      <path
        d="M623.8 62.5c-1.7-8.1-21.8-31.4-39.6-33.5-20.7-2.3-26.7 8.3-26.7 8.3s-3-7-14.3-5-9.7 16.8-9.7 16.8-2.4-.8-5.8-1.6c.6.6 1.3 1.2 2.1 1.8-29.4 12.9 44.9 45.7 44.5 22.6 5.7 4.8 13.8 6.6 21.1 4.8 7.2-1.9 13.5-7.3 16.2-14.3 3.9 1.3 8.9 1.9 12.2.1z"
        fill="url(#prefix__c)"
      />
      <linearGradient
        id="prefix__d"
        gradientUnits="userSpaceOnUse"
        x1={611.361}
        y1={34.045}
        x2={537.528}
        y2={94.545}
      >
        <stop offset={0.001} stopColor="#c2d4fb" />
        <stop offset={0.033} stopColor="#c4d6fb" />
        <stop offset={0.333} stopColor="#d5e9fc" />
        <stop offset={0.648} stopColor="#dff3fd" />
        <stop offset={1} stopColor="#e2f7fd" />
      </linearGradient>
      <path
        d="M594.2 36.3s12.5-4.2 20.8 7c-2.4-14-13.1-15.9-20.8-7z"
        fill="url(#prefix__d)"
      />
      <path
        d="M569.7 60.8s13-5.4 22.6 5.8c-3.6-14.7-15.2-15.8-22.6-5.8z"
        fill="#e2f7fd"
      />
      <path
        d="M584.9 59.4s13-5.4 22.6 5.8c-3.7-14.6-15.2-15.7-22.6-5.8zM529.6 46.1s13.3-5.6 23.3 5.9c-3.8-15-15.6-16.2-23.3-5.9z"
        fill="#e2f7fd"
      />
      <path
        d="M545.2 44.8s13.3-5.6 23.3 5.9c-3.8-15.1-15.6-16.2-23.3-5.9zM574.5 36.8s16.1-6.7 28.2 7.2c-4.6-18.2-18.9-19.6-28.2-7.2z"
        fill="#e2f7fd"
      />
      <path
        d="M562.7 39.9s17-7.1 29.6 7.5c-4.8-19.1-19.8-20.5-29.6-7.5z"
        fill="#e2f7fd"
      />
    </g>
  );
};

export default LittlePigsStaticElements;
